import { useLocation } from 'react-router-dom';
import { getRouteKeyFromPath, type RouteKey } from '../router/langRoutes';

// Hook để lấy routeKey hiện tại từ pathname
export function useCurrentRouteKey(): RouteKey | null {
  const location = useLocation();
  return getRouteKeyFromPath(location.pathname);
}